import React from 'react';
import styled from 'styled-components';

import { Button } from '@components/form-elements/buttons/Button';
import { AttentionIcon } from '@components/icons/status-icons/Attention';
import { routes } from '@routes';
import { useAuthContext } from '@providers/AuthProvider';
import { useNavigate } from 'react-router';
import { useModalContext } from '@providers/ModalProvider';

const ModalWrapper = styled.div`
  background: #ffffff;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  position: relative;
  padding: 30px;
  width: 330px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 30px;

  .icon {
    margin: 0 auto;
  }

  .buttonContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;

    button {
      width: 130px;
    }
  }
`;

type TProps = {
  onCancel: () => void;
};

export const UpgradeToAIFeatures = ({ onCancel }: TProps) => {
  const { closeModal } = useModalContext();
  const navigate = useNavigate();
  const { organization } = useAuthContext();

  const goToBilling = (evt: React.MouseEvent<HTMLButtonElement>) => {
    closeModal();
    evt.preventDefault();
    navigate(routes.billingAccount.make(organization?.slug ?? ''));
  };

  return (
    <ModalWrapper>
      <AttentionIcon className="icon" />
      <div>
        If you want to use AI to improve the quality of your transcript, upgrade to Growth, Pro or Enterprise plans
      </div>
      <div className="buttonContainer">
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={goToBilling}>Go to Upgrade</Button>
      </div>
    </ModalWrapper>
  );
};
